import { ArrowRight, FlaskConical, RefreshCw } from 'lucide-react'
import type { NewsFeedState } from '../../hooks/useNewsFeed'
import type { NewsItem } from '../../types/news'
import type { NewsEditionTab } from './NewsEditionSwitch'
import { getNewsSourcePresentation } from './newsCuration'
import './newsExperience.css'

const fullDeskHref: Record<NewsEditionTab, string> = {
  ai: '/news',
  robots: '/news/robots',
  cybersecurity: '/news/cybersecurity',
}

const deskLabel: Record<NewsEditionTab, string> = {
  ai: 'AI NEWS DESK',
  robots: 'ROBOTICS NEWS DESK',
  cybersecurity: 'CYBERDEFENSE NEWS DESK',
}

const formatEditionTime = (iso: string | undefined) => iso
  ? new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }).format(new Date(iso))
  : 'newer edition'

export function NewsEditionUpdateNotice({ feed }: { feed: NewsFeedState }) {
  if (!feed.hasNewEdition || !feed.pendingData) return null
  return <aside className="news-edition-update" aria-label="News edition update" data-current-edition={feed.data?.refreshedAt} data-pending-edition={feed.pendingData.refreshedAt}>
    <RefreshCw aria-hidden="true"/>
    <span aria-live="polite"><strong>NEW EDITION AVAILABLE</strong><small>Published {formatEditionTime(feed.pendingData.refreshedAt)}. Your current edition stays in place until you choose to refresh.</small></span>
    <button type="button" onClick={feed.applyNewEdition}>LOAD NEW EDITION <ArrowRight aria-hidden="true"/></button>
  </aside>
}

export function NewsSourceTypeBadge({ item }: { item: NewsItem }) {
  const source = getNewsSourcePresentation(item)
  return <span className={`news-source-type news-source-type--${source.type}`} title={source.description}>{source.label}</span>
}

export function ResearchWatch({ items, edition }: { items: NewsItem[]; edition: NewsEditionTab }) {
  if (!items.length) return null
  const headingId = `${edition}-research-watch-heading`
  return <section className="news-research-watch" aria-labelledby={headingId}>
    <header><FlaskConical aria-hidden="true"/><span><h2 id={headingId}>RESEARCH WATCH</h2><small>Preprints are discovery signals, not peer-reviewed findings.</small></span></header>
    <div>{items.map((item) => <article key={item.id}>
      <span>PREPRINT · NOT PEER REVIEWED</span>
      <h3>{item.title}</h3>
      <p>{item.publisher}</p>
      <a href={item.url} target="_blank" rel="noreferrer">OPEN PAPER <ArrowRight aria-hidden="true"/></a>
    </article>)}</div>
  </section>
}

export function HomeNewsDeskLink({ edition, shown, available }: { edition: NewsEditionTab; shown: number; available: number }) {
  return <nav className="news-home-desk-link" aria-label={`Continue to the full ${deskLabel[edition].toLowerCase()}`}>
    <span><strong>HOME BRIEFING COMPLETE</strong><small>{shown} selected {shown === 1 ? 'story' : 'stories'} from {available} available signals.</small></span>
    <a href={fullDeskHref[edition]}>OPEN FULL {deskLabel[edition]} <ArrowRight aria-hidden="true"/></a>
  </nav>
}
